import {subdebug} from '../debug.js'

/**
 * Debug logger for telemetry store operations
 * @internal
 */
export const telemetryStoreDebug = subdebug('telemetry:telemetryStore')
